module.exports = __webpack_public_path__ + "static/img/bg.3ce6f93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/share/bg.png
// module id = oqfX
// module chunks = 1